export type CatalogTab = 'public' | 'private'

const PREFIX = 'aeam.catalog.tab'

/**
 * The remembered tab is scoped to the user AND the tenant: one account administers several tenants
 * through the tenant switcher, and each tenant has its own private catalog. A single key would
 * carry one tenant's choice into the next.
 */
export function catalogTabKey(userId?: string | null, tenantId?: string | null): string {
  return `${PREFIX}.${tenantId || 'none'}.${userId || 'anon'}`
}

/**
 * Public is the default. It holds the certified packages and is where a tenant subscribes them
 * into its private catalog, which starts empty — landing on Private shows a new tenant nothing.
 *
 * Super admin has no Private tab, so a value remembered from a tenant session must not select a
 * tab with no button to switch back from.
 */
export function readCatalogTab(key: string, superAdmin: boolean): CatalogTab {
  if (superAdmin) return 'public'
  try {
    return window.localStorage.getItem(key) === 'private' ? 'private' : 'public'
  } catch {
    // Private-browsing and storage-disabled profiles throw on read.
    return 'public'
  }
}

export function writeCatalogTab(key: string, tab: CatalogTab): void {
  try {
    window.localStorage.setItem(key, tab)
  } catch {
    /* remembered for this page view only */
  }
}
